import { MDSPlainButtonProps } from '@marqvision/mds-v2';
import { DomainNamesRouteEnum } from '~/router/@types';
import {
  MarqBrandEnumsWebsiteBrandSortedColumnEnum,
  MarqCommonEnumsScannedStatusEnum,
  MarqCommonEnumsSortedOrderEnum,
  MarqCommonEnumsSwAiLabelEnum,
} from '~/swagger/data-contracts';
import { DomainNamesColumnEnum, DomainNamesTabGroupEnum, ReportStatus, SortValue } from './@types';

export const SCANNED_STATUS_DROPDOWN_LIST = [
  {
    label: 'All',
    value: MarqCommonEnumsScannedStatusEnum.All,
  },
  {
    label: 'Recently scanned',
    value: MarqCommonEnumsScannedStatusEnum.RecentlyScanned,
  },
  {
    label: 'Irrelevant',
    value: MarqCommonEnumsScannedStatusEnum.Irrelevant,
  },
];

export const TAB_INFO = {
  [DomainNamesTabGroupEnum.Scanned]: {
    key: DomainNamesTabGroupEnum.Scanned,
    label: 'Scanned',
    path: DomainNamesRouteEnum.Scanned,
  },
  [DomainNamesTabGroupEnum.Flagged]: {
    key: DomainNamesTabGroupEnum.Flagged,
    label: 'Flagged',
    path: DomainNamesRouteEnum.Flagged,
  },
  [DomainNamesTabGroupEnum.InProgress]: {
    key: DomainNamesTabGroupEnum.InProgress,
    label: 'In progress',
    children: [
      {
        label: 'Requested',
        path: DomainNamesRouteEnum.Requested,
      },
      {
        label: 'Reported',
        path: DomainNamesRouteEnum.Reported,
      },
    ],
  },
  [DomainNamesTabGroupEnum.CaseClosed]: {
    key: DomainNamesTabGroupEnum.CaseClosed,
    label: 'Case closed',
    children: [
      {
        label: 'Removed',
        path: DomainNamesRouteEnum.Removed,
      },
      {
        label: 'Denied',
        path: DomainNamesRouteEnum.Denied,
      },
      {
        label: 'Dismissed',
        path: DomainNamesRouteEnum.Dismissed,
      },
      {
        label: 'Not enforceable',
        path: DomainNamesRouteEnum.NonEnforceable,
      },
    ],
  },
  [DomainNamesTabGroupEnum.Watchlist]: {
    key: DomainNamesTabGroupEnum.Watchlist,
    label: 'Watchlist',
    path: DomainNamesRouteEnum.Watchlist,
  },
} as const;

export const COLUMN_LIST: Record<DomainNamesRouteEnum, DomainNamesColumnEnum[]> = {
  [DomainNamesRouteEnum.Scanned]: [
    DomainNamesColumnEnum.Domain,
    DomainNamesColumnEnum.Screenshot,
    DomainNamesColumnEnum.IpAddress,
    DomainNamesColumnEnum.Title,
    DomainNamesColumnEnum.Country,
    DomainNamesColumnEnum.Tag,
    DomainNamesColumnEnum.FirstScanned,
    DomainNamesColumnEnum.MetaDescription,
    DomainNamesColumnEnum.Registrant,
    DomainNamesColumnEnum.Registrar,
    DomainNamesColumnEnum.HostingProvider,
    DomainNamesColumnEnum.MxRecords,
    DomainNamesColumnEnum.SslCertificate,
    DomainNamesColumnEnum.LogoDetected,
    DomainNamesColumnEnum.RegistrationDate,
    DomainNamesColumnEnum.ExpirationDate,
    DomainNamesColumnEnum.Actions,
  ],
  [DomainNamesRouteEnum.Flagged]: [
    DomainNamesColumnEnum.Domain,
    DomainNamesColumnEnum.Screenshot,
    DomainNamesColumnEnum.IpAddress,
    DomainNamesColumnEnum.Title,
    DomainNamesColumnEnum.Country,
    DomainNamesColumnEnum.Tag,
    DomainNamesColumnEnum.Comment,
    DomainNamesColumnEnum.FirstScanned,
    DomainNamesColumnEnum.MetaDescription,
    DomainNamesColumnEnum.Registrant,
    DomainNamesColumnEnum.Registrar,
    DomainNamesColumnEnum.HostingProvider,
    DomainNamesColumnEnum.MxRecords,
    DomainNamesColumnEnum.SslCertificate,
    DomainNamesColumnEnum.LogoDetected,
    DomainNamesColumnEnum.RegistrationDate,
    DomainNamesColumnEnum.ExpirationDate,
    DomainNamesColumnEnum.Actions,
  ],
  [DomainNamesRouteEnum.Requested]: [
    DomainNamesColumnEnum.Domain,
    DomainNamesColumnEnum.Screenshot,
    DomainNamesColumnEnum.IpAddress,
    DomainNamesColumnEnum.Title,
    DomainNamesColumnEnum.Country,
    DomainNamesColumnEnum.Tag,
    DomainNamesColumnEnum.Comment,
    DomainNamesColumnEnum.FirstScanned,
    DomainNamesColumnEnum.MetaDescription,
    DomainNamesColumnEnum.Registrant,
    DomainNamesColumnEnum.Registrar,
    DomainNamesColumnEnum.HostingProvider,
    DomainNamesColumnEnum.MxRecords,
    DomainNamesColumnEnum.SslCertificate,
    DomainNamesColumnEnum.LogoDetected,
    DomainNamesColumnEnum.RegistrationDate,
    DomainNamesColumnEnum.ExpirationDate,
    DomainNamesColumnEnum.Actions,
  ],
  [DomainNamesRouteEnum.Reported]: [
    DomainNamesColumnEnum.Domain,
    DomainNamesColumnEnum.Screenshot,
    DomainNamesColumnEnum.IpAddress,
    DomainNamesColumnEnum.Title,
    DomainNamesColumnEnum.Country,
    DomainNamesColumnEnum.Tag,
    DomainNamesColumnEnum.Comment,
    DomainNamesColumnEnum.FirstScanned,
    DomainNamesColumnEnum.MetaDescription,
    DomainNamesColumnEnum.Registrant,
    DomainNamesColumnEnum.Registrar,
    DomainNamesColumnEnum.HostingProvider,
    DomainNamesColumnEnum.MxRecords,
    DomainNamesColumnEnum.SslCertificate,
    DomainNamesColumnEnum.LogoDetected,
    DomainNamesColumnEnum.RegistrationDate,
    DomainNamesColumnEnum.ExpirationDate,
    DomainNamesColumnEnum.Actions,
  ],
  [DomainNamesRouteEnum.Removed]: [
    DomainNamesColumnEnum.Domain,
    DomainNamesColumnEnum.Screenshot,
    DomainNamesColumnEnum.IpAddress,
    DomainNamesColumnEnum.Title,
    DomainNamesColumnEnum.Country,
    DomainNamesColumnEnum.Tag,
    DomainNamesColumnEnum.Comment,
    DomainNamesColumnEnum.FirstScanned,
    DomainNamesColumnEnum.MetaDescription,
    DomainNamesColumnEnum.Registrant,
    DomainNamesColumnEnum.Registrar,
    DomainNamesColumnEnum.HostingProvider,
    DomainNamesColumnEnum.MxRecords,
    DomainNamesColumnEnum.SslCertificate,
    DomainNamesColumnEnum.LogoDetected,
    DomainNamesColumnEnum.RegistrationDate,
    DomainNamesColumnEnum.ExpirationDate,
    DomainNamesColumnEnum.Actions,
  ],
  [DomainNamesRouteEnum.Dismissed]: [
    DomainNamesColumnEnum.Domain,
    DomainNamesColumnEnum.Screenshot,
    DomainNamesColumnEnum.IpAddress,
    DomainNamesColumnEnum.Title,
    DomainNamesColumnEnum.Country,
    DomainNamesColumnEnum.Tag,
    DomainNamesColumnEnum.Comment,
    DomainNamesColumnEnum.FirstScanned,
    DomainNamesColumnEnum.MetaDescription,
    DomainNamesColumnEnum.Registrant,
    DomainNamesColumnEnum.Registrar,
    DomainNamesColumnEnum.HostingProvider,
    DomainNamesColumnEnum.MxRecords,
    DomainNamesColumnEnum.SslCertificate,
    DomainNamesColumnEnum.LogoDetected,
    DomainNamesColumnEnum.RegistrationDate,
    DomainNamesColumnEnum.ExpirationDate,
    DomainNamesColumnEnum.Actions,
  ],
  [DomainNamesRouteEnum.Denied]: [
    DomainNamesColumnEnum.Domain,
    DomainNamesColumnEnum.Screenshot,
    DomainNamesColumnEnum.IpAddress,
    DomainNamesColumnEnum.Title,
    DomainNamesColumnEnum.Country,
    DomainNamesColumnEnum.Tag,
    DomainNamesColumnEnum.Comment,
    DomainNamesColumnEnum.FirstScanned,
    DomainNamesColumnEnum.MetaDescription,
    DomainNamesColumnEnum.Registrant,
    DomainNamesColumnEnum.Registrar,
    DomainNamesColumnEnum.HostingProvider,
    DomainNamesColumnEnum.MxRecords,
    DomainNamesColumnEnum.SslCertificate,
    DomainNamesColumnEnum.LogoDetected,
    DomainNamesColumnEnum.RegistrationDate,
    DomainNamesColumnEnum.ExpirationDate,
    DomainNamesColumnEnum.Actions,
  ],
  [DomainNamesRouteEnum.NonEnforceable]: [
    DomainNamesColumnEnum.Domain,
    DomainNamesColumnEnum.Screenshot,
    DomainNamesColumnEnum.IpAddress,
    DomainNamesColumnEnum.Title,
    DomainNamesColumnEnum.Country,
    DomainNamesColumnEnum.Tag,
    DomainNamesColumnEnum.Comment,
    DomainNamesColumnEnum.FirstScanned,
    DomainNamesColumnEnum.MetaDescription,
    DomainNamesColumnEnum.Registrant,
    DomainNamesColumnEnum.Registrar,
    DomainNamesColumnEnum.HostingProvider,
    DomainNamesColumnEnum.MxRecords,
    DomainNamesColumnEnum.SslCertificate,
    DomainNamesColumnEnum.LogoDetected,
    DomainNamesColumnEnum.RegistrationDate,
    DomainNamesColumnEnum.ExpirationDate,
    DomainNamesColumnEnum.Actions,
  ],
  [DomainNamesRouteEnum.Watchlist]: [
    DomainNamesColumnEnum.Domain,
    DomainNamesColumnEnum.Screenshot,
    DomainNamesColumnEnum.IpAddress,
    DomainNamesColumnEnum.Title,
    DomainNamesColumnEnum.Country,
    DomainNamesColumnEnum.Tag,
    DomainNamesColumnEnum.Comment,
    DomainNamesColumnEnum.FirstScanned,
    DomainNamesColumnEnum.MetaDescription,
    DomainNamesColumnEnum.Registrant,
    DomainNamesColumnEnum.Registrar,
    DomainNamesColumnEnum.HostingProvider,
    DomainNamesColumnEnum.MxRecords,
    DomainNamesColumnEnum.SslCertificate,
    DomainNamesColumnEnum.LogoDetected,
    DomainNamesColumnEnum.RegistrationDate,
    DomainNamesColumnEnum.ExpirationDate,
    DomainNamesColumnEnum.Actions,
  ],
  [DomainNamesRouteEnum.Monitoring]: [],
};

export const STATUS_TAG_DATA: Record<
  ReportStatus,
  {
    label: string;
    color: MDSPlainButtonProps['color'];
  }
> = {
  reviewing: {
    label: 'Requested',
    color: 'bluegray',
  },
  requested: {
    label: 'Requested',
    color: 'bluegray',
  },
  reported: {
    label: 'Reported',
    color: 'bluegray',
  },
  denied: {
    label: 'Denied',
    color: 'red',
  },
  delisted: {
    label: 'Delisted',
    color: 'green',
  },
  removed: {
    label: 'Removed',
    color: 'green',
  },
};

export const SORT_LABEL: Record<SortValue, string> = {
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`]:
    'First scanned (Newest)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`]:
    'First scanned (Oldest)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`]: 'Domain (Z-A)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`]: 'Domain (A-Z)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`]:
    'Requested date (Newest)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`]:
    'Requested date (Oldest)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.UpdatedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`]:
    'Added date (Newest)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.UpdatedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`]:
    'Added date (Oldest)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.WatchlistAddedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`]:
    'Added date (Newest)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.WatchlistAddedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`]:
    'Added date (Oldest)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.CommentDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`]:
    'Comments (Newest)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.CommentDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`]:
    'Comments (Oldest)',
};

export const SORT_LIST: Record<DomainNamesRouteEnum, SortValue[]> = {
  [DomainNamesRouteEnum.Scanned]: [
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
  ],
  [DomainNamesRouteEnum.Flagged]: [
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.CommentDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
  ],
  [DomainNamesRouteEnum.Requested]: [
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.CommentDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
  ],
  [DomainNamesRouteEnum.Reported]: [
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.CommentDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
  ],
  [DomainNamesRouteEnum.Removed]: [
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
  ],
  [DomainNamesRouteEnum.Dismissed]: [
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.UpdatedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.UpdatedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
  ],
  [DomainNamesRouteEnum.Denied]: [
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.UpdatedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.UpdatedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
  ],
  [DomainNamesRouteEnum.NonEnforceable]: [
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.UpdatedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.UpdatedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
  ],
  [DomainNamesRouteEnum.Watchlist]: [
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.CommentDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.WatchlistAddedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.WatchlistAddedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
  ],
  [DomainNamesRouteEnum.Monitoring]: [],
};

export const AI_VERDICT_LABEL: Record<MarqCommonEnumsSwAiLabelEnum, string> = {
  [MarqCommonEnumsSwAiLabelEnum.Impersonation]: 'Impersonation',
  [MarqCommonEnumsSwAiLabelEnum.ParkedDomain]: 'Parked',
  [MarqCommonEnumsSwAiLabelEnum.InactiveDomain]: 'Inactive',
  [MarqCommonEnumsSwAiLabelEnum.Clean]: 'Clean',
  [MarqCommonEnumsSwAiLabelEnum.NotSure]: 'Not sure',
  [MarqCommonEnumsSwAiLabelEnum.Failed]: 'Failed',
  [MarqCommonEnumsSwAiLabelEnum.Abnormal]: 'Abnormal',
};
